import { apiBaseUrl } from '../../config'
import store from '../../store'

// getters
const getters = {
  assets: state => state.assets,
  selectedAsset: state => state.asset
}

const actions = {
  loadAssets(context) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/assets?token=${store.state.user.token}&projectId=${store.state.project.project.id}`, {
        method: "get"
      }).then(res => {
        return res.json()
      }).then(function(data) {
        data.map(item => {
          item.clone = false
          item.actions = false
        })
        context.commit('loadAssets', data)
        resolve()
      }).catch(e => {
        context.commit('loadAssets', [])
        console.error(e)
        reject()
      });
    })
  },
  createAsset(context, data) {
    return new Promise((resolve, reject) => {
      if (data.projectId === undefined) {
        data.projectId = store.state.project.project.id ? store.state.project.project.id : ""
      }
      fetch(`${apiBaseUrl}/api/assets?token=${store.state.user.token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('createAsset', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  saveAsset(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/assets?token=${store.state.user.token}`, {
        method: "put",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('saveAsset', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  deleteAsset(context, asset) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/assets?token=${store.state.user.token}&projectId=${store.state.project.project.id}`, {
        method: "delete",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(asset)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        data.map(item => {
          item.clone = false
          item.actions = false
        })
        context.commit('deleteAsset', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  setAsset(context, asset) {
    context.commit('setAsset', asset)
  },
  unsetAsset(context) {
    context.commit('unsetAsset')
  }
}

const mutations = {
  setAsset(state, asset) {
    Object.assign(state.asset, asset)
  },
  unsetAsset(state) {
    Object.assign(state.asset, {
      title: '',
      src: '',
      content: [],
      visible: false
    })
  },
  loadAssets(state, assets) {
    state.asset.visible = false
    state.assets = assets
  },
  createAsset(state, asset) {
    asset.actions = false
    asset.clone = false
    asset.visible = false
    if (this.state.project.project.id === asset.projectId) {
      state.assets.unshift(asset)
      state.asset = asset
    }
  },
  saveAsset(state, asset) {
    asset.visible = false
    Object.assign(state.asset, asset)
    state.assets.map(a => {
      if (a.id === asset.id) {
        Object.assign(a, asset)
      }
    });
  },
  deleteAsset(state, assets) {
    state.assets = assets
    if (assets.length > 0) {
      Object.assign(state.asset, assets[0])
    } else {
      Object.assign(state.asset, {
        title: '',
        src: '',
        content: [],
        visible: false
      })
    }
  }
}
export default {
  state: initializeState(),
  mutations,
  actions,
  getters
}

function initializeState() {
  return {
    assets: [],
    asset: {
      title: '',
      src: '',
      content: [],
      visible: false
    }
  }
}
